/**
 * Teacher subject type -> view mapping.
 */
export const SUBJECT_TYPE_VIEW = {
  UNIT_ASSESSMENTS: 'fym',
  ASSESSMENTS: 'pre-ap',
  QUESTION_BANK: 'qb',
};
